const FormControl = {
  defaultProps: {
    variant: 'filled',
  },
};

export default FormControl;
